import React from 'react'
import PropTypes from 'prop-types'
import PageContainer from '../PageContainer/PageContainer'
import GettingStartedV1 from './v1/GettingStarted'
import GettingStartedV2 from './v2/GettingStarted'
import { defaultPrivateWealthEmail } from 'utils/links'

const GettingStarted = (props) => {
  const {
    goOnboardingPersonalInformation,
    goAboutYou,
    hide,
    prospect,
    isLoading
  } = props

  const linkHref = `mailto:${defaultPrivateWealthEmail}`
  const greeting = `Hi ${prospect.firstName},`
  const description = !prospect.onboardingFinancialAccountsVisible ?
    ['Welcome to Ellevest Private Wealth Management.'] : []

  return (
    <PageContainer
      name={greeting}
      description={description}
      hide={hide || isLoading}
      isLoading={isLoading}>
      {
        !prospect.onboardingFinancialAccountsVisible ?
          <GettingStartedV1
            goToNextSection={goOnboardingPersonalInformation}
            linkHref={linkHref} /> :
          <GettingStartedV2
            goToNextSection={goAboutYou}
            linkHref={linkHref} />
      }
    </PageContainer>
  )
}

GettingStarted.propTypes = {
  goOnboardingPersonalInformation: PropTypes.func.isRequired,
  goAboutYou: PropTypes.func.isRequired,
  hide: PropTypes.bool.isRequired,
  prospect: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
}

export default GettingStarted



// WEBPACK FOOTER //
// ./src/components/Onboarding/GettingStarted/GettingStarted.jsx